import { Link } from "react-router-dom";
import { Download, ArrowUpRight } from "lucide-react";
import { SITE } from "../lib/site";

export default function LandownerPack() {
  return (
    <section data-testid="landowner-pack" className="bg-[#0B0F0E]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-28">
        <div className="border border-[#C9A24B]/30 bg-gradient-to-br from-[#11171A] to-[#0B0F0E] p-10 md:p-14 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="overline"><span className="h-line" />Landowner pack</div>
            <h3 className="font-display text-[#F4EFE6] text-4xl md:text-5xl mt-5 leading-[0.95]">
              The <span className="italic-gold">credentials</span> document — yours to keep.
            </h3>
            <p className="text-[#9BA39B] mt-5 leading-relaxed max-w-xl">
              A four-page introduction to Upsurge Strategic Land — our approach, agreement structures, sample timelines and answers to the most common landowner questions. Helpful to read with family or your solicitor.
            </p>
          </div>
          <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
            <a
              data-testid="landowner-pack-download"
              href="/landowner-pack.html"
              target="_blank"
              rel="noreferrer"
              className="usl-btn"
            >
              <Download size={16} /> Download / Print
            </a>
            <Link
              data-testid="landowner-pack-contact"
              to="/contact"
              className="usl-btn-outline"
            >
              Request posted copy <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
